export const DISTRIBUTION_MODE = Object.freeze({
  ACH: 'ACH',
  CHECK: 'CHECK',
});

export const STEPS = ['Account Selection', 'Transfer To', 'Tax Information', 'Transfer Details'];

export const DEFAULT_DISTRIBUTION_FEE = 60;
